import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { productShortName, systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-slate-800 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-238" data-mp="3bh233qpffq8m">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-239" data-mp="36j0mrdjdy50u">
        <span className="metal inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-slate-950" data-id="element-240" data-mp="31l8taf33eauj">
          <AwardIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-241" data-mp="2wsphnnnytpsd" /> The most comprehensive industrial instrumentation
          teaching system in the world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-242" data-mp="2nudk11oolrqf">
          {productShortName}
        </h2>
        <p className="mt-3 font-semibold text-slate-200" data-id="element-243" data-mp="2dveehrz7qc7n">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach industrial instrumentation with
          confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-244" data-mp="18qzqfqn3p4j8">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-slate-400/20 bg-slate-900 p-4 text-sm font-semibold text-slate-200" data-id="element-245" data-mp="u2v6ykg84oze">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-246" data-mp="1cr9wt4et1wym" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl metal p-6 text-left text-lg font-bold leading-relaxed text-slate-950 shadow-lg shadow-black/30" data-id="element-247" data-mp="1c3cpsipyaep">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-slate-700" aria-hidden="true" data-id="element-248" data-mp="28xv4kvgkmdwq" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          industrial instrumentation works, why accurate measurement matters, and how instrumentation contributes to safe,
          efficient process control while maintaining ethical and safety responsibility.
        </p>
      </div>
    </section>;
}